import Cookie from 'js-cookie';
import { storage } from '@ok/blade';

import utils from '@common/utils';

import { cleanUserMigrationData } from './userMigration/utils';

// comb-trade资金交易密码对应token在退出时清除
const combTradeStorage =
  storage.getInstance('comb_trade') ||
  storage.init({
    project: 'comb_trade',
  });
const {
  utils: { ont },
} = window;

// 登出
export default function logout() {
  const token = localStorage.getItem('token');

  if (token && token.toString().length) {
    ont.post('/v3/users/login-auth/logout', undefined, {
      headers: { Authorization: token },
    });
  }

  const clearLocalStorageKeys = [
    'token',
    'nickName',
    'loginName',
    'step2Type',
    'currentIsSub',
    'dangerLogin',
    '_tk',
  ];

  clearLocalStorageKeys.forEach((key) => {
    localStorage.removeItem(key);
  });

  combTradeStorage.remove('tradeToken');

  Cookie.set('isLogin', '', { expires: -1 });
  Cookie.set('kycNationality', '', { expires: -1 });

  cleanUserMigrationData();

  window.location.href = utils.getLoginUrl();
}
